// The archive and practice picker on the landing screen.
//
// Deliberately small: a row of recent days and a row of layouts, both as plain links. Links rather
// than buttons because the mode lives in the URL — so a player can bookmark a layout they are
// practising, or send someone the exact day they are talking about, and the back button behaves.

import { TEMPLATES } from '../engine/templates'
import type { PlayMode } from './mode'

/** How many days back the archive offers. A week is enough to catch up on and short enough to scan. */
const ARCHIVE_DAYS = 7

function shiftKey(key: string, days: number): string {
  const d = new Date(`${key}T00:00:00Z`)
  d.setUTCDate(d.getUTCDate() + days)
  return d.toISOString().slice(0, 10)
}

export function renderPicker(el: HTMLElement, todayKey: string, mode: PlayMode): void {
  const days: string[] = []
  for (let i = 1; i <= ARCHIVE_DAYS; i++) days.push(shiftKey(todayKey, -i))

  const current =
    mode.kind === 'archive' ? mode.key : mode.kind === 'practice' ? mode.templateId : todayKey

  const day = (key: string, label: string, href: string) =>
    `<a class="pick${key === current ? ' is-current' : ''}" href="${href}">${label}</a>`

  el.innerHTML = [
    '<p class="pick-head">EARLIER DAYS</p>',
    '<div class="pick-row">',
    day(todayKey, 'TODAY', '/'),
    ...days.map((k) => day(k, k.slice(5), `/?day=${k}`)),
    '</div>',
    '<p class="pick-head">PRACTICE A LAYOUT</p>',
    '<div class="pick-row">',
    // A random sample of each layout, chosen when the landing is drawn: practice should hand you a
    // fresh variant rather than the same seed forever. `Math.random` is banned below src/engine/ and
    // this is not there — nothing here reaches the simulation, which seeds itself from the sample.
    ...TEMPLATES.map((t) =>
      day(t.id, t.name.toUpperCase(), `/?practice=${t.id}&n=${Math.floor(Math.random() * 40)}`),
    ),
    '</div>',
    '<p class="account-note">Only today counts. Earlier days and practice are yours alone.</p>',
  ].join('')
}
